'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _rcSlider = require('rc-slider');

var _rcSlider2 = _interopRequireDefault(_rcSlider);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var Year = _react2['default'].createClass({
  displayName: 'Year',

  PropTypes: {
    handleYear: _react2['default'].PropTypes.func.isRequired
  },
  handleSlide: function handleSlide(val) {
    this.props.handleYear(val);
  },
  render: function render() {
    // return(
    //   <input id="yearBar" style={_w} type="range"
    //     defaultValue="2014" min="1999" max="2014"
    //     onChange={this.handleSlide}/>
    // )
    return _react2['default'].createElement(_rcSlider2['default'], { id: 'yearBar',
      defaultValue: 2014, min: 1999, max: 2014,
      onChange: this.handleSlide,
      tipTransitionName: 'zoom-down' });
  }
});
exports.Year = Year;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9rYXJlbi9Eb2N1bWVudHMvbXlfcHJvamVjdC9mb29kL3NyYy9qcy9jb250cm9sL3llYXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7d0JBQXFCLFdBQVc7Ozs7cUJBQ2QsT0FBTzs7OztBQUVsQixJQUFNLElBQUksR0FBRyxtQkFBTSxXQUFXLENBQUM7OztBQUNwQyxXQUFTLEVBQUM7QUFDUixjQUFVLEVBQUUsbUJBQU0sU0FBUyxDQUFDLElBQUksQ0FBQyxVQUFVO0dBQzVDO0FBQ0QsYUFBVyxFQUFBLHFCQUFDLEdBQUcsRUFBQztBQUNkLFFBQUksQ0FBQyxLQUFLLENBQUMsVUFBVSxDQUFDLEdBQUcsQ0FBQyxDQUFBO0dBQzNCO0FBQ0QsUUFBTSxFQUFBLGtCQUFFOzs7Ozs7QUFNTixXQUNFLDBEQUFVLEVBQUUsRUFBQyxTQUFTO0FBQ3BCLGtCQUFZLEVBQUUsSUFBSSxBQUFDLEVBQUMsR0FBRyxFQUFFLElBQUksQUFBQyxFQUFDLEdBQUcsRUFBRSxJQUFJLEFBQUM7QUFDekMsY0FBUSxFQUFFLElBQUksQ0FBQyxXQUFXLEFBQUM7QUFDM0IsdUJBQWlCLEVBQUMsV0FBVyxHQUFZLENBQzVDO0dBQ0Y7Q0FDRixDQUFDLENBQUEiLCJmaWxlIjoiL1VzZXJzL2thcmVuL0RvY3VtZW50cy9teV9wcm9qZWN0L2Zvb2Qvc3JjL2pzL2NvbnRyb2wveWVhci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSY3NsaWRlciBmcm9tICdyYy1zbGlkZXInXG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5cbmV4cG9ydCBjb25zdCBZZWFyID0gUmVhY3QuY3JlYXRlQ2xhc3Moe1xuICBQcm9wVHlwZXM6e1xuICAgIGhhbmRsZVllYXI6IFJlYWN0LlByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWRcbiAgfSxcbiAgaGFuZGxlU2xpZGUodmFsKXtcbiAgICB0aGlzLnByb3BzLmhhbmRsZVllYXIodmFsKVxuICB9LFxuICByZW5kZXIoKXtcbiAgICAvLyByZXR1cm4oXG4gICAgLy8gICA8aW5wdXQgaWQ9XCJ5ZWFyQmFyXCIgc3R5bGU9e193fSB0eXBlPVwicmFuZ2VcIlxuICAgIC8vICAgICBkZWZhdWx0VmFsdWU9XCIyMDE0XCIgbWluPVwiMTk5OVwiIG1heD1cIjIwMTRcIiBcbiAgICAvLyAgICAgb25DaGFuZ2U9e3RoaXMuaGFuZGxlU2xpZGV9Lz5cbiAgICAvLyApXG4gICAgcmV0dXJuIChcbiAgICAgIDxSY3NsaWRlciBpZD1cInllYXJCYXJcIlxuICAgICAgICBkZWZhdWx0VmFsdWU9ezIwMTR9IG1pbj17MTk5OX0gbWF4PXsyMDE0fSBcbiAgICAgICAgb25DaGFuZ2U9e3RoaXMuaGFuZGxlU2xpZGV9XG4gICAgICAgIHRpcFRyYW5zaXRpb25OYW1lPSd6b29tLWRvd24nPjwvUmNzbGlkZXI+XG4gICAgKVxuICB9XG59KSJdfQ==